import { getSysNotices } from '@/api/common'
import { getInviteList } from '@/api/invite-friend'
import { BOOL_NUMBER, CACHE_KEY, CONFERENCE_ACT_STATUS, CONFERENCE_STATE, INVITE_STATUS, NOTIFY_TYPE } from '@/utils/constant'
import { db } from '@/utils/db'
import { isArray, isEmpty, isString } from '@/utils/is'
import { patchList } from '@/utils/ops'
import Vue from 'vue'
// let sysNoticeTime
function prependListToOrigin(list, origins, uniqueKey) {
  for (let j = list.length - 1; j >= 0; j--) {
    const item = list[j]
    const ukey = item[uniqueKey]
    const index = origins.findIndex((origin) => origin[uniqueKey] === ukey)
    if (index > -1) {
      origins.splice(index, 1)
    }
    origins.unshift(item)
  }
}

function resetState() {
  return {
    notifications: [], // 添加好友通知已读
    cocNotifications: [], // 会议通知
    unreadNotifications: [], // 未读通知
    isreading: false,
    unreadCount: 0,
    nextLoadCocNotifyVer: Date.now(),
    sysnotices: [] // 系统通知
  }
}

const state = resetState()

/** @type {import('vuex').MutationTree<typeof state>} */
const mutations = {
  resetState(state) {
    const initState = resetState()
    for (const key in initState) {
      state[key] = initState[key]
    }
  },
  // 追加notifications到列表
  appendNotify(state, ntfs) {
    if (isArray(ntfs)) {
      state.notifications.push(...ntfs)
    } else {
      state.notifications.push(ntfs)
    }
  },
  // 添加未读消息
  prependUnreadNotify(state, ntfs) {
    // ntfs.uKey相同则认为是同一个通知，排到最前面
    const _ntfs = isArray(ntfs) ? ntfs : [ntfs]

    const originNtfs = state.unreadNotifications // 采用splice和push操作，无需slice原数据

    prependListToOrigin(_ntfs, originNtfs, 'uKey')

    state.unreadCount = state.unreadNotifications.length
  },
  setNotify(state, ntfs) {
    state.notifications = ntfs
  },
  setUnreadNotify(state, ntfs) {
    state.unreadNotifications = ntfs
    state.unreadCount = ntfs.length
  },
  async setReading(state, { isreading, rootState }) {
    if (isreading) {
      const uKeyPrefix = `${NOTIFY_TYPE.IM_MSG_RELAY_NTY}|`
      const uKeyPrefixEx = `${NOTIFY_TYPE.IM_MSG_RELAY_NTY}_`
      const uKeyPreFixSys = `${NOTIFY_TYPE.SYSTEM_NOTICE}_`
      // 从已读状态切换到未读状态时，把未读的转存到已读
      const unReadCocNotifys = []
      const unReadNotifys = []
      const unReadSysnotices = []

      state.unreadNotifications.forEach(notify => {
        // 仅有两种情况，因此暂时写成这种if...else 后续跟进
        if (isString(notify.uKey) && (notify.uKey.startsWith(uKeyPrefix) || notify.uKey.startsWith(uKeyPrefixEx))) {
          unReadNotifys.push(notify)
        } else if (isString(notify.uKey) && notify.uKey.startsWith(uKeyPreFixSys)){
          // 系统通知
          unReadSysnotices.push(notify)
        } else {
          unReadCocNotifys.push(notify)
        }
      })

      prependListToOrigin(unReadNotifys, state.notifications, 'uKey')

      const belongUser = rootState.userInfo.id
      if (unReadSysnotices.length > 0){
        prependListToOrigin(unReadSysnotices, state.sysnotices, 'uKey')
      }
      await db.sysNotify.where({ belongUser }).modify({ readTime: getFormatDate() })

      if (unReadCocNotifys.length > 0) {
        prependListToOrigin(unReadCocNotifys, state.cocNotifications, 'uKey')
        db.cocNotify.bulkPut(unReadCocNotifys.map(({ uKey, beginTime, endTime, actType, operator, theme, conferenceId, notifyType, conferenceState, confirmStatus, attendStatus, hostIsMe, updateAt, belongUser }) => ({ uKey, isReading: BOOL_NUMBER.TRUE, beginTime, endTime, actType, operator, theme, conferenceId, notifyType, conferenceState, confirmStatus, attendStatus, hostIsMe, updateAt, belongUser })))
      }

      state.unreadNotifications = []
    }

    state.isreading = isreading
    state.unreadCount = 0

    function getFormatDate(d = new Date()){
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    }
  },
  prependReadNotify(state, notify) {
    prependListToOrigin(isArray(notify) ? notify : [notify], state.notifications, 'uKey')
  },
  prependCocReadNofity(state, notify) {
    prependListToOrigin(isArray(notify) ? notify : [notify], state.cocNotifications, 'uKey')
  },
  // 从db里面按排序查出，直接追加，无需计算
  appendCocReadNotify(state, notify) {
    state.cocNotifications = state.cocNotifications.concat(notify)
  },
  addUnreadCount(state, total = 1) {
    if (!state.isreading) {
      state.unreadCount += total
    }
  },
  updateNotify(state, ops) {
    state.notifications = patchList(state.notifications, ops)
  },
  updateCocNotify(state, ops) {
    state.cocNotifications = patchList(state.cocNotifications, ops)
  },
  updateUnreadNotify(state, ops) {
    state.unreadNotifications = patchList(state.unreadNotifications, ops)
  },
  setSysNotices (state, notices) {
    state.sysnotices = notices
  }
}

const actions = {
  lsStorage({ rootState }, data) {
    const myId = rootState.userInfo.id
    const storageKey = `${CACHE_KEY.NOTY_PREFIX}_${myId}_`
    if (isEmpty(data)) {
      return Vue.ls.remove(storageKey)
    } else if (isArray(data)) {
      Vue.ls.set(storageKey, data)
    }
  },
  doReading({ dispatch, commit, rootState }, isreading) {
    // 假设此处省略了对服务端消息盒子是否已读的状态的修改请求
    if (isreading) { // 直接清空本地未读消息的ids
      dispatch('lsStorage', null)
    }
    commit('setReading', { isreading, rootState })
  },
  // mqtt接口
  addUnreadNotify({ state, commit, dispatch }, notify) {
    const uKey = notify.uKey
    const unreadUKeys = state.unreadNotifications.filter(ntf => ntf.uKey !== uKey).map(ntf => ntf.uKey).concat(uKey)
    commit('addUnreadCount')
    commit('prependUnreadNotify', notify)
    dispatch('lsStorage', unreadUKeys)
  },
  // 获取通知的详情 mqtt接口
  async unshiftUnreadNotify({ commit, dispatch, state, rootState }, payload) {
    const notifyType = payload.notifyType
    const myId = rootState.userInfo.id

    if (notifyType === NOTIFY_TYPE.IM_MSG_RELAY_NTY) {
      // 邀请好友
      const { userId, inviteId, type: actType } = payload.data
      const uKey = actType === INVITE_STATUS.RECEIVE ? `${NOTIFY_TYPE.IM_MSG_RELAY_NTY}|${userId}` : `${NOTIFY_TYPE.IM_MSG_RELAY_NTY}_${inviteId}` // uKey相同，则认为是同一个通知
      // 103|10676 收到对方的添加申请
      // 103_12042
      const userInfo = await dispatch('user/fetchUser', { uid: userId }, { root: true })
      const { corpId, corpName, name, avatar } = userInfo

      const notify = {
        corpId,
        corpName,
        userId,
        name,
        avatar,
        inviteId,
        notifyType,
        uKey,
        actType,
      }

      if (state.isreading) {
        commit('prependReadNotify', notify)
      } else {
        dispatch('addUnreadNotify', notify)
      }

      if (actType === INVITE_STATUS.ACCEPT || actType === INVITE_STATUS.ACCEPT_YOU) {
        dispatch('collaborator/getCompanyTree', null, { root: true })
      }

      return userInfo
    } else if (notifyType === NOTIFY_TYPE.COC_NTY) {
      const { beginTime, endTime, type: actType, operator, theme, conferenceId, conferenceState, confirmStatus, attendStatus, hostIsMe } = payload.data
      const updateAt = Date.now()
      const notify = { beginTime, endTime, actType, operator, theme, conferenceId, notifyType, conferenceState, confirmStatus, attendStatus, hostIsMe, updateAt, belongUser: myId }

      if (actType === CONFERENCE_ACT_STATUS.CANCEL_NTY) {
        await dispatch('coc/syncCocData', {
          conferenceId,
          changeData: { conferenceState: CONFERENCE_STATE.CANCELED },
          limit: Infinity
        }, { root: true })
      }

      const uKey = await db.cocNotify.add({ beginTime, endTime, actType, operator, theme, conferenceId, notifyType, conferenceState, confirmStatus, attendStatus, hostIsMe, updateAt, belongUser: myId, isReading: state.isreading ? BOOL_NUMBER.TRUE : BOOL_NUMBER.FALSE })

      notify.uKey = uKey
      if (state.isreading) {
        commit('prependCocReadNofity', notify)
      } else {
        dispatch('addUnreadNotify', notify)
      }
    }
  },
  updateManyNotify({ commit }, ops) {
    commit('updateNotify', ops)
    commit('updateUnreadNotify', ops)
  },
  updateManyCocNotify({ commit }, ops) {
    commit('updateCocNotify', ops)
    commit('updateUnreadNotify', ops)
  },
  async loadCocNotify({ commit, state, rootState }, limit) {
    const belongUser = rootState.userInfo.id

    const notifyList = await db.cocNotify.where({ belongUser, isReading: BOOL_NUMBER.TRUE }).reverse().offset(state.cocNotifications.length).limit(limit).sortBy('updateAt')
    commit('appendCocReadNotify', notifyList)
    return notifyList
  },
  stopFetchSysNotices(){
    clearInterval(window.sysNoticesTimer)
  },
  async fetchSysNotices({ commit, state, rootState, dispatch }) {
    const belongUser = rootState.userInfo.id
    const list = await getSysNotices()
    if (Array.isArray(list.items) && list.items.length) {
      const item = list.items[0]
      const row = {
        actType: -1, // 接受等待，不可用参数
        corpId: '', // 公司ID
        corpName: '', // 公司名称
        inviteId: item.id, // 消息ID
        name: '', // 用户名
        notifyType: 99999, // 系统通知类型
        uKey: '99999_' + belongUser,
        userId: belongUser, // 用户ID，主动，被动用户名
        belongUser, // 用户ID，主动，被动用户名
        info: item.content,
        title: item.title,
        startTime: item.startTime,
        endTime: item.endTime,
        status: item.status,
        readTime: null
      }

      const sysNotify = await db.sysNotify.where({ belongUser, inviteId: item.id }).first()
      if (sysNotify) {
        const now = getFormatDate()
        // 没有查看 || 小于当前时间，都要添加红点
        if (!sysNotify.readTime || (+new Date(sysNotify.readTime) < +new Date(now))) {
          await db.sysNotify.where({ belongUser }).delete()
          await db.sysNotify.put(sysNotify)
          commit('prependUnreadNotify', [row])
        }
        commit('setSysNotices', [row])
      } else {
        await db.sysNotify.put(row)
        commit('prependUnreadNotify', [row])
        commit('setSysNotices', [row])
      }
    }

    window.sysNoticesTimer = setInterval(_ => {
      clearInterval(window.sysNoticesTimer)
      dispatch('fetchSysNotices')
    }, 600000) // 10分

    function getFormatDate(d = new Date()){
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    }
  },
  async fetchNotifyList({ commit, dispatch, rootState }) {
    const myId = rootState.userInfo.id
    const storageKey = `${CACHE_KEY.NOTY_PREFIX}_${myId}_`

    // 获取好友相关的通知列表
    const data = await getInviteList()

    const inviteByUkey = {}
    const unreadUkeys = Vue.ls.get(storageKey) || []
    const readUkeys = []

    data.list.forEach(({ inviteInfo }) => {
      if (!inviteInfo) {
        return
      }
      const { status, source, corpId, corpName, name, uid: userId, inviteId } = inviteInfo

      let actType = -1
      if (source === 1) { // 我发出的
        if (status === 1) {
          actType = INVITE_STATUS.ACCEPT_YOU
        } else if (status === 2) {
          actType = INVITE_STATUS.REJECT_YOU
        }
      } else if (source === 2) { // 我收到的
        if (status === 0) {
          actType = INVITE_STATUS.RECEIVE
        } else if (status === 1) {
          actType = INVITE_STATUS.ACCEPT
        } else if (status === 2) {
          actType = INVITE_STATUS.REJECT
        }
      }

      if (actType === -1) {
        return
      }

      // 收到对方的添加申请 ? 103|uid : 103_id
      const uKey = actType === INVITE_STATUS.RECEIVE ? `${NOTIFY_TYPE.IM_MSG_RELAY_NTY}|${userId}` : `${NOTIFY_TYPE.IM_MSG_RELAY_NTY}_${inviteId}`
      if (inviteByUkey[uKey]) {
        return
      }

      const notify = {
        notifyType: NOTIFY_TYPE.IM_MSG_RELAY_NTY,
        actType,
        userId,
        corpId,
        corpName,
        name,
        inviteId,
        uKey,
      }
      inviteByUkey[uKey] = notify

      if (!unreadUkeys.includes(uKey)) {
        readUkeys.push(uKey)
      }
    })

    const uKeyPrefix = `${NOTIFY_TYPE.IM_MSG_RELAY_NTY}|`

    commit('setNotify', readUkeys.map(ukey => inviteByUkey[ukey]))

    const unreadCocNotifyList = await db.cocNotify.where({
      belongUser: myId,
      isReading: BOOL_NUMBER.FALSE
    })
      .reverse()
      .sortBy('updateAt') // 这里的数据是不可靠数据，涉及到状态变更，还需要结合上面的请求才是可靠的，过于复杂；在点击 接受/拒绝 按钮时处理这类异常以简化问题

    const unreadCocNotifyByUKey = {}

    console.error(unreadCocNotifyList, myId)

    unreadCocNotifyList.forEach(notify => {
      unreadCocNotifyByUKey[notify.uKey] = notify
    })

    const unreadNotifyList = []
    unreadUkeys.forEach(uKey => {
      let notify = null
      if (isString(uKey) && uKey.startsWith(uKeyPrefix)) {
        notify = inviteByUkey[uKey]
      } else {
        notify = unreadCocNotifyByUKey[uKey]
      }
      if (notify) {
        unreadNotifyList.push(notify)
      }
    })

    commit('prependUnreadNotify', unreadNotifyList)
  }
}

const getters = {
  existsUnreadNotify: (state) => state.unreadCount > 0
}

const notifyModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default notifyModule
